<template>
  <v-alert class="mt-6 mb-6" type="warning">
    {{ t("devices.assign.onboardingAlert.title") }}<br />
    <a href="#" class="text-decoration-underline" @click="handleSignHereClick">
      {{ t("devices.assign.onboardingAlert.link") }}
    </a>
  </v-alert>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "vue-i18n";
import { API } from "@/plugins/api";
import { useApplicationStore } from "@/store/application";
import { useMerchantsStore } from "@/store/merchants";

const merchantsStore = useMerchantsStore();
const applicationStore = useApplicationStore();
const api = inject<API>("api");
const { t } = useI18n();

const handleSignHereClick = async () => {
  try {
    await merchantsStore.initialize(false);
    const result = await api!.merchant.requestOnboardingLink(
      merchantsStore.currentMerchant!.merchantId,
    );
    window.open(result, "_self");
  } catch (error) {
    console.error(error);
    applicationStore.notifyUser({
      message: t("devices.assign.onboardingAlert.hostedLinkError"),
      type: "error",
    });
  }
};
</script>
